import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageUrl: string;
  articleCount: number;
}

export default function CategoryCard({
  slug,
  name,
  description,
  icon,
  imageUrl,
  articleCount,
}: CategoryCardProps) {
  return (
    <Link
      to={`/category/${slug}`}
      className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-300/60"
    >
      <div className="relative w-full h-40 overflow-hidden">
        <img
          src={imageUrl}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
        <div className="absolute bottom-3 left-3 flex items-center gap-2">
          <div className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
            <i className={`${icon} text-base`}></i>
          </div>
          <span className="text-sm font-medium text-white">{articleCount} 篇文章</span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200">
          {name}
        </h3>
        <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {description}
        </p>
      </div>
    </Link>
  );
}